import { Platform } from 'react-native';
import { registerRootComponent } from 'expo';
import App from './App';
import { enableLegacyWebImplementation } from 'react-native-gesture-handler';
import * as WebBrowser from "expo-web-browser";
import { configureProductionLogging } from './Config';

// Configure production logging FIRST - before any other code runs
// This ensures console logging is disabled in production web builds
configureProductionLogging();

// Import React 19 polyfills FIRST on web
if (Platform.OS === 'web') {
  require('./src/polyfills/react-dom-findDOMNode.web');
  // Polyfill for gesture handler withTestId on web
  require('./src/polyfills/gesture-handler-withTestId.web');
}

// ONLY register service worker on web (service workers don't exist on iOS/Android)
if (Platform.OS === 'web') {
  const { register } = require('./src/registerServiceWorker');
  register();
}

WebBrowser.maybeCompleteAuthSession();

if(Platform.OS ==='web'){
  require('@inovua/reactdatagrid-community/index.css');
  require('@inovua/reactdatagrid-community/theme/default-light.css');
  // require('./web/css/lib/index.css');
  require("./web/css/lib/editor.quill.snow.css");
  // require('@tamagui/core/reset.css');
  require('./web/css/style.min.css');
}

// if (__DEV__ && Platform.OS === 'web') {
//   const whyDidYouRender = require('@welldone-software/why-did-you-render');
//   whyDidYouRender(React, {
//     trackAllPureComponents: true,
//   });
// }

if (Platform.OS === 'web') { 
  enableLegacyWebImplementation(true) 
};

registerRootComponent(App);